document.addEventListener("DOMContentLoaded", function () {
  const searchInputs = document.querySelectorAll(".customSearchInput");

  searchInputs.forEach((input) => {
    const closestMegaMenu = input.closest(".megamenu-wrapper");
    const resultsContainer = closestMegaMenu.querySelector(".customSearchResults");
    const linkBlocks = closestMegaMenu?.querySelectorAll(".link-block");

    const linkItems = Array.from(closestMegaMenu?.querySelectorAll(".link-block a")).map((item) => ({
      text: item.textContent.trim(),
      url: item.href,
    }));

    const debounce = (func, wait) => {
      let timeout;
      return function executedFunction(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(...args), wait);
      };
    };

    input.addEventListener(
      "input",
      debounce(function (e) {
        const searchTerm = e.target.value.toLowerCase();
        resultsContainer.innerHTML = "";

        if (searchTerm.length > 0) {
          resultsContainer.classList.remove("hidden")
          linkBlocks.forEach((block) => (block.style.visibility = "hidden"));
        } else {
          resultsContainer.classList.add("hidden")
          linkBlocks.forEach((block) => (block.style.visibility = "visible"));
        }

        const filteredLinks = linkItems.filter((item) =>
          item.text.toLowerCase().includes(searchTerm)
        );

        if (filteredLinks.length === 0) {
          resultsContainer.innerHTML = "<li>No results found</li>";
        } else {
          filteredLinks.forEach((item) => {
            const li = document.createElement("li");
            const a = document.createElement("a");
            a.href = item.url;
            a.textContent = item.text;
            li.appendChild(a);
            resultsContainer.appendChild(li);
          });
        }
      }, 300)
    );
  });
});
